import React, { useState } from 'react'

export default function Textarea(props) {
  const handleUpClick = ()=>{
    // console.log("upper case was click" + text)
    let newText = text.toUpperCase();
    setText(newText)
  }

  const handleLowerClick = ()=>{
    // console.log("upper case was click" + text)
    let newText = text.toLowerCase();
    setText(newText)
  }

  const hadleToClear = ()=>{
    // console.log("upper case was click" + text)
    let newText = text.toLowerCase();
    setText(" ")
  }

    const handleOnChange = (event)=>{
      // console.log("onChange")
      setText(event.target.value)
  }

  const [text, setText] = useState("")
  // setText("hii")
  return (
    <>
    <div>
      <h1>{props.heading}</h1>
      <div className="mb-3">
        <textarea className="form-control" value={text} onChange={handleOnChange} id="myBox" rows="8"></textarea>
      </div>
      <button className="btn btn-primary" onClick={handleUpClick}>Convert to UPPER CASE</button>
      <button className="btn btn-warning mx-1" onClick={handleLowerClick}>Convert to LowerCase</button>
      <button className="btn btn-danger" onClick={hadleToClear}>Clear All</button>

    </div>

    <hr />

    <div className="container my-3">
      <h1>Text Summary...</h1>
      <p>{text.split(" ").length} word and {text.length} charectors</p>
    </div>
    </>
  )
}
